export function HeroGauge() {
  const R = 150, C = 2 * Math.PI * R, arc = C * 0.75;
  return (
    <svg viewBox="0 0 400 400" className="hero-gauge pointer-events-none absolute -right-24 -top-16 h-[520px] w-[520px] opacity-[0.16] dark:opacity-25 md:-right-10 md:-top-10" aria-hidden="true">
      <defs>
        <linearGradient id="hg" x1="0" x2="1">
          <stop offset="0%" stopColor="hsl(var(--primary))" stopOpacity="0.2" />
          <stop offset="100%" stopColor="hsl(var(--primary))" />
        </linearGradient>
      </defs>
      <g transform="rotate(135 200 200)">
        <circle cx="200" cy="200" r={R} fill="none" stroke="currentColor" strokeWidth="18" strokeDasharray={`${arc} ${C}`} strokeLinecap="round" className="text-border" />
        <circle cx="200" cy="200" r={R} fill="none" stroke="url(#hg)" strokeWidth="18" strokeDasharray={`${arc} ${C}`} strokeLinecap="round" className="hero-gauge-arc" />
      </g>
      {Array.from({ length: 13 }).map((_, i) => {
        const a = (135 + i * 22.5) * (Math.PI / 180);
        return <line key={i} x1={200 + Math.cos(a) * 118} y1={200 + Math.sin(a) * 118} x2={200 + Math.cos(a) * 128} y2={200 + Math.sin(a) * 128} stroke="currentColor" strokeWidth={i % 3 === 0 ? 3 : 1.5} className="text-foreground/60" />;
      })}
      <g className="hero-gauge-needle" style={{ transformOrigin: "200px 200px" }}>
        <line x1="200" y1="200" x2="200" y2="92" stroke="hsl(var(--primary))" strokeWidth="5" strokeLinecap="round" />
        <circle cx="200" cy="200" r="12" fill="hsl(var(--primary))" />
      </g>
    </svg>
  );
}
